import { ClaimState } from '@/types/claim'

export const state = () => {
	return {
		nbClaimsToSend: 0,
		nbClaimsToSendGifting: 0,
	}
}

export const actions = {
	async getNbClaimsToSend({ commit }, { companyId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/claims/`, {
				params: {
					state: ClaimState.Pending,
					limit: 1,
					distrib_mode: 'DIR',
					promo_type: 'BAD,PRO,PER,PRO,SHI,BON,BXGY,BXGYP,CUS',
				},
			})
			.then((res) => {
				commit('setNbClaimsToSend', res.count)
				return res.count
			})
	},

	async getNbClaimsToSendGifting({ commit }, { companyId, campaignId }) {
		return await useNuxtApp()
			.$api(`api/company/${companyId}/claims/`, {
				params: {
					state: ClaimState.Pending,
					limit: 1,
					distrib_mode: 'DIR',
					promo_type: 'GIF',
					campaign: campaignId,
				},
			})
			.then((res) => {
				commit('setNbClaimsToSendGifting', res.count)
				return res.count
			})
	},

	async list(_, { companyId, params }) {
		const paramsClone = { ...params }
		for (const key in paramsClone) {
			if (Array.isArray(paramsClone[key])) {
				paramsClone[key] = paramsClone[key].join(',')
			}
		}

		return await useNuxtApp().$api(`api/company/${companyId}/claims/`, { params: paramsClone })
	},

	async next(_, { pageURL }) {
		return await useNuxtApp()
			.$api(pageURL)
			.then((res) => {
				return res
			})
	},

	async exportCSV(_, { params, companyId }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/claims/export/`, {
			method: 'POST',
			body: {
				filter_data: params,
			},
		})
	},

	async partialUpdate(_, { companyId, claimId, data }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/claims/${claimId}/`, {
			method: 'PATCH',
			body: data,
		})
	},

	async massCreate(_, { companyId, data }) {
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/claims/mass-create/`, {
				method: 'POST',
				body: data,
			})
			.then((res) => res.creator_ids_claim)
	},

	async massUpdate(_, { companyId, params }) {
		return await useNuxtApp().$api(`/api/company/${companyId}/claims/mass-update/`, {
			method: 'PATCH',
			body: params,
		})
	},

	async addRewardToCreator({ commit }, { companyId, creatorId, reward }) {
		try {
			const res = await useNuxtApp().$api(`/api/company/${companyId}/claims/`, {
				method: 'POST',
				body: {
					creator: creatorId,
					raw_reward: reward,
				},
			})
			return res
		} finally {
			commit('dashboardLoyalty/invalidateStatsRewards', null, { root: true })
		}
	},
}

export const mutations = {
	setNbClaimsToSend(state, data) {
		state.nbClaimsToSend = data
	},

	setNbClaimsToSendGifting(state, data) {
		state.nbClaimsToSendGifting = data
	},
}
